angular.module('bmsApp.dashboard').controller('DashboardTileBreakdownCtrl', function ($scope, $q, DashboardApiSvc, $timeout, $modalInstance, params) {

console.info('DashboardTileBreakdownCtrl');
console.info(params);

	var self = {
		loading: false,
		tileType: params.tileType,
		methods: {
			close: function () {
				$modalInstance.close();
			},
			init: init
		},
		chart: {
			template: null,
			data: null,
			instance: undefined
		},
		frequencies: null,
		dataColumnName: null
	};

	$scope.dashboardTileBreakdownCtrl = self;

	self.chart.template = {
		chart: {
			type: 'pie'
		},
		title: {
			text: 'Chart Title'
		},
		plotOptions: {
			pie: {
				dataLabels: {
					enabled: false
				},
				showInLegend: true
			}
		},
		tooltip: {
			pointFormat: '<b>{point.y}</b> ({point.percentage:.1f}%)'
		},
		series: [
			{
				name: 'Active Customers - By Frequency',
				data: []
			}
		],
		credits: {
			enabled: false
		}
	};

	function init() {

		self.loading = true;

		var promise = [];
		if (self.tileType == 'active_customers') {
			promise.push(DashboardApiSvc.activeCustomersBreakdown({filter: params.filter }));
		}
		else if (self.tileType == 'new_customers') {
			promise.push(DashboardApiSvc.newCustomersBreakdown({filter: params.filter }));
		}
		else if (self.tileType == 'last_active_customers') {
			promise.push(DashboardApiSvc.lostCustomersBreakdown({filter: params.filter }));
		}
		else if (self.tileType == 'lost_customers') {
			promise.push(DashboardApiSvc.inactiveCustomersBreakdown({filter: params.filter }));
		}
		else if (self.tileType == 'initiative revenue') {
			promise.push(DashboardApiSvc.initiativeRevenueBreakdown({filter: params.filter }));
		}
		else if (self.tileType == 'inactive cleans') {
			promise.push(DashboardApiSvc.inactiveCleansBreakdown({filter: params.filter }));
		}

		$q.all(promise).then(function(response) {
			$timeout(function() {
				self.frequencies = response[0].data.frequencyCustomerBreakdown;
				self.chart.data = response[0].data.frequencyChart;

				self.chart.template.series[0].data = self.chart.data;
				self.chart.template.title.text = response[0].data.chartTitle;
				self.dataColumnName = response[0].data.dataColumnName;

				if (self.chart.instance) {
					self.chart.instance.reflow();
				}
				self.customerBreakdown = response[0].data.customer_breakdown;
				self.loading = false;
			},50);
		});

	}


});
